import { createSlice } from "@reduxjs/toolkit";
import { loadAssets } from "./assetsSlice";

// Import universal initializeGame action
import { initializeGame } from "./gameSettingsSlice";

const loadingProgressSlice = createSlice({
  name: "loadingProgress",
  initialState: {
    status: "idle", // idle, loading, success, error
    loaderComplete: false, // true after loader "out" animation finishes
    loaderFadedOut: false, // true after loader fade-out animation visually completes
    // True once the loader's fade-out is halfway through — i.e. the game
    // underneath is already half-revealed. Distinct from loaderFadedOut
    // (which is the very end): this is the cue for anything that should
    // cross-fade IN as the loader goes OUT, rather than wait for it to
    // finish and leave a visible gap.
    loaderFadeMidpoint: false,
  },
  reducers: {
    setLoaderComplete: (state) => {
      state.loaderComplete = true;
    },
    setLoaderFadedOut: (state) => {
      state.loaderFadedOut = true;
    },
    setLoaderFadeMidpoint: (state) => {
      state.loaderFadeMidpoint = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadAssets.pending, (state) => {
        if (state.status === "idle") {
          state.status = "loading";
        }
      })
      .addCase(initializeGame.fulfilled, (state) => {
        state.status = "success";
      })
      .addCase(initializeGame.rejected, (state) => {
        state.status = "error";
      });
  },
});

export const { setLoaderComplete, setLoaderFadedOut, setLoaderFadeMidpoint } =
  loadingProgressSlice.actions;

export const selectLoaderFadeMidpoint = (state) =>
  state.loadingProgress.loaderFadeMidpoint;
export default loadingProgressSlice.reducer;
